<template>
  <div class="section py-0">
    <div class="section pb-0">
      <div class="columns">
        <div class="column">
          <b-button
            type="is-gold is-outlined"
            icon-left="plus"
            icon-pack="fas"
            tag="router-link"
            :to="{ name: 'NewProduct' }"
            >Neues Produkt</b-button
          >
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon-pack="fas"
              icon="search"
            >
            </b-input>
          </b-field>
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-select v-model="rangeRows" placeholder="Select a name">
              <option value="10">10 pro Seite</option>
              <option value="50">50 pro Seite</option>
              <option value="100">100 pro Seite</option>
              <option value="500">500 pro Seite</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-narrow">
          <b-dropdown
            :triggers="['hover']"
            aria-role="list"
            position="is-bottom-left"
          >
            <template #trigger>
              <b-button type="is-gold is-outlined" icon-right="caret-down">
                Aktionen
              </b-button>
            </template>

            <b-dropdown-item
              aria-role="listitem"
              @click="confirmBulkDeactivation"
              >Deaktivieren</b-dropdown-item
            >
            <b-dropdown-item aria-role="listitem" @click="confirmBulkDelete"
              >Löschen</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="section">
      <b-table
        :data="filteredProducts"
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        :paginated="filteredProducts.length > 10"
        :per-page="rangeRows"
        striped
        hoverable
      >
        <b-table-column field="icon" label="Icon" width="40" v-slot="props">
          <b-icon :icon="props.row.icon" icon-pack="fas"></b-icon>
        </b-table-column>

        <b-table-column field="name" label="Produkt" v-slot="props">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="subscriber" label="Abonnenten" v-slot="props">
          <OrgLicenseCounter
            :data="orgsByLicense(props.row.id)"
            :tooltipPos="tooltipPos(props.row.id)"
          ></OrgLicenseCounter>
        </b-table-column>

        <b-table-column
          field="enabled"
          label="Status"
          width="40"
          sortable
          v-slot="props"
        >
          <b-icon
            :type="props.row.enabled ? 'is-success' : 'is-danger'"
            icon-pack="fas"
            icon="circle"
          ></b-icon>
        </b-table-column>

        <b-table-column
          field="comment"
          label="Kommentar"
          width="300"
          v-slot="props"
        >
          <b-tooltip
            v-if="isTooLong(props.row.comment, 33)"
            :label="props.row.comment"
            :position="commentTooltipPos(props.row.id)"
            size="is-large"
            type="is-gold is-light"
            multilined
          >
            {{ truncate(props.row.comment, 33) }}
          </b-tooltip>
          <span v-else>{{ props.row.comment }}</span>
        </b-table-column>

        <b-table-column field="action" label="" width="40" v-slot="props">
          <router-link
            :to="{ name: 'ViewProduct', params: { productId: props.row.id } }"
          >
            <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
          </router-link>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helper from '@/functions/helper';
import OrgLicenseCounter from '@/components/editOrg/OrgLicenseCounter.vue';

export default {
  name: 'AllProducts',
  components: {
    OrgLicenseCounter,
  },
  data() {
    return {
      search: '',
      checkedRows: [],
      rangeRows: 10,
    };
  },
  computed: {
    ...mapGetters({
      products: 'product/data',
      productOrder: 'product/order',
      productOrgs: 'product/org/dataByParentId',
      orgById: 'org/dataById',
    }),
    filteredProducts() {
      return helper.search(this.products, ['name', 'comment'], this.search);
    },
  },
  methods: {
    orgsByLicense(productId) {
      return this.productOrgs(productId)
        .map((id) => this.orgById(id))
        .reduce(
          (acc, org) => {
            if (org.test) {
              acc.test.count += 1;
              acc.test.orgs.push(org.name);
            } else {
              acc[org.license_type].count += 1;
              acc[org.license_type].orgs.push(org.name);
            }

            return acc;
          },
          {
            main: { type: 'Haupt', count: 0, orgs: [] },
            sub: { type: 'Unter', count: 0, orgs: [] },
            test: { type: 'Test', count: 0, orgs: [] },
          },
        );
    },
    confirmBulkDeactivation() {
      this.$buefy.dialog.confirm({
        title: 'Produkt deaktivieren',
        // eslint-disable-next-line max-len
        message: 'Sind Sie sicher, dass Sie alle ausgewählen Produkte deaktivieren möchten?',
        confirmText: 'Produkte deaktivieren',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.bulkAction(this.disableProduct),
      });
    },
    confirmBulkDelete() {
      this.$buefy.dialog.confirm({
        title: 'Produkt löschen',
        // eslint-disable-next-line max-len
        message:
          'Sind Sie sicher, dass Sie alle ausgewählen Produkte löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden!',
        confirmText: 'Produkte löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.bulkAction(this.deleteProduct),
      });
    },
    disableProduct(data) {
      this.$store.dispatch('product/UPDATE', {
        id: data.id,
        enabled: false,
      });
    },
    deleteProduct(data) {
      this.$store.dispatch('product/DELETE', {
        id: data.id,
      });
    },
    bulkAction(action) {
      this.checkedRows.forEach(action);
      this.checkedRows = [];
    },
    tooltipPos(productId) {
      return this.productOrder.indexOf(productId) === 0 ? 'is-bottom' : 'is-top';
    },
    isTooLong(str, limit) {
      return helper.isTooLong(str, limit);
    },
    truncate(str, limit) {
      return helper.truncate(str, limit);
    },
    commentTooltipPos(id) {
      const index = this.filteredProducts.findIndex((product) => product.id === id);
      return index === 0 ? 'is-bottom' : 'is-top';
    },
  },
};
</script>
<style lang="scss">
.b-table {
  .table {
    td {
      vertical-align: middle;
    }
  }
}
</style>
